import {  default_post } from "../default";

export function getHistoryCenter() {
    return default_post({ }, '/paas/history/center' )
}

export function getHistoryPlan(plan) {
    return default_post({ id: plan}, '/paas/history/plan')
}

export function getHistorySolutionCenter(plan) {
    return default_post({ id: plan }, '/paas/history/solutionCenter' )
}

export function getHistorySolutionPlan(plan) {
    return default_post({ id: plan}, '/paas/history/solutionPlan')
}
